"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.UNIT_OF_TIME = void 0;
require("moment");
exports.UNIT_OF_TIME = {
    years: 'years',
    months: 'months',
    weeks: 'weeks',
    days: 'days',
    hours: 'hours',
    minutes: 'minutes',
    seconds: 'seconds',
    milliseconds: 'milliseconds',
};
//# sourceMappingURL=unitOfTime.js.map